// src/i18n.js
import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import HttpApi from "i18next-http-backend";

const I18N_VERSION = "20260717b";

i18n
    .use(HttpApi)                    // Load translations from /public/locales
    .use(LanguageDetector)           // Detect browser language
    .use(initReactI18next)           // Connect with React
    .init({
        supportedLngs: ["en", "ka", "es", "de"],
        fallbackLng: "en",
        debug: false,

        detection: {
            order: ["localStorage", "navigator", "htmlTag"],
            caches: ["localStorage"],
        },

        backend: {
            // ?v= busts browser/CDN caches — bump I18N_VERSION whenever
            // translation.json files change, or stale caches serve old
            // files and new keys render as raw key names.
            loadPath: "/locales/{{lng}}/translation.json?v=" + I18N_VERSION,
        },
    });

export default i18n;
